/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RoleSummaryResponse {
    getFixupPrototypeFunction() { return RoleSummaryResponse.fixupPrototype; }

    static newInstance(model: Partial<RoleSummaryResponse>): RoleSummaryResponse {
        let obj = Object.assign(new RoleSummaryResponse(), model);
        RoleSummaryResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RoleSummaryResponse>): RoleSummaryResponse {
        if (!model) return null;
        return RoleSummaryResponse.newInstance(<RoleSummaryResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RoleSummaryResponse) {
        if (!obj) return;

        models.RoleSummaryResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RoleSummaryResponse): boolean {
        Object.setPrototypeOf(obj, RoleSummaryResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.total_roles === undefined) {
            this.total_roles = 0;
        }
        if (this.system_roles === undefined) {
            this.system_roles = 0;
        }
        if (this.custom_roles === undefined) {
            this.custom_roles = 0;
        }
    }

    /**
     * Total number of roles matching the filters
     */
    total_roles: number;

    /**
     * Number of system (default category) roles
     */
    system_roles: number;

    /**
     * Number of custom roles
     */
    custom_roles: number;

}
